import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';
import MWSVG from '../common/svg';

const LlmsTechStack = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="LLMs & Models">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_chatgpt.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenAI"
                                            title="OpenAI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OpenAI</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="ic-Anthropic-Claude" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Anthropic</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_gemini.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Gemini"
                                            title="Gemini"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Gemini</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/hugging-face.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hugging Face"
                                            title="Hugging Face"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Hugging Face</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_mistralai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Mistral AI"
                                            title="Mistral AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Mistral AI</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Frameworks">
                                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_langchain.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LangChain"
                                            title="LangChain"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LangChain</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_llamaindex_color.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LlamaIndex"
                                            title="LlamaIndex"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LlamaIndex</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Vector Databases">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_pinecone.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Pinecone"
                                            title="Pinecone"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Pinecone</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_milvus.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Milvus"
                                            title="Milvus"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Milvus</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_weaviate.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Weaviate"
                                            title="Weaviate"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Weaviate</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_chroma.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Chroma"
                                            title="Chroma"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Chroma</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_faiss.svg"
                                            className="img-fluid mb-2.5"
                                            alt="FAISS"
                                            title="FAISS"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">FAISS</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Governance & MLOps">
                                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_langsmith.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LangSmith"
                                            title="LangSmith"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LangSmith</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_mcp.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MCP"
                                            title="MCP"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">MCP</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LlmsTechStack;
